import { render, staticRenderFns } from "./contentPage.vue?vue&type=template&id=66306470&scoped=true&"
import script from "./contentPage.vue?vue&type=script&lang=js&"
export * from "./contentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66306470",
  null
  
)

export default component.exports